export default {"ENV":"production","API_ENV":"","SENTRY":"https://ba6e0a8892c1416e9996bfefc8e5c044@sentry.io/1263604","APP_VERSION":"2.1.2"}